import { api, type ApiType } from 'lib/api';
import { stringParse } from 'utils';

export const apiViews: ApiType = {
  get: {
    list: ({ vars }) => api.get(stringParse('/api/views/{0}', vars)),
    byId: ({ vars }) => api.get(stringParse('/api/views/{0}/{1}', vars)),
  },
  post: {
    create: ({ vars, data }) => api.post(stringParse('/api/views/{0}', vars), data),
  },
  put: {
    update: ({ vars, data }) => api.put(stringParse('/api/views/{0}/{1}', vars), data),
    reorder: ({ vars, data }) => api.put(stringParse('/api/views/{0}/order', vars), data),
  },
  delete: {
    byId: ({ vars }) => api.delete(stringParse('/api/views/{0}/{1}', vars)),
  },
};
